import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterNone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 189.5,
			cy: 105.48,
			r: 95.11,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M235.53 120.78 35.01 52.33 27.92 73.1a18 18 0 0 0 .43 12.74l50.54 121.03c.6 1.41.68 3 .25 4.46l-11.02 37.43a4.6 4.6 0 0 0 2.91 5.64l12.45 4.25a4.6 4.6 0 0 0 5.75-2.68l14.17-36.36a6.7 6.7 0 0 1 2.92-3.38l114-64.86a18 18 0 0 0 8.13-9.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M84.97 260.7q-1.05.01-2.08-.34l-12.44-4.25a6.4 6.4 0 0 1-4.08-7.87l11.02-37.43a5 5 0 0 0-.18-3.25L26.67 86.53a19.8 19.8 0 0 1-.47-14.03l7.08-20.75a1.8 1.8 0 0 1 2.31-1.14l200.53 68.45a1.8 1.8 0 0 1 1.13 2.3l-7.08 20.76a19.8 19.8 0 0 1-8.95 10.82l-114 64.86a5 5 0 0 0-2.12 2.46l-14.17 36.36a6.4 6.4 0 0 1-5.96 4.09M36.14 54.66l-6.5 19.03a16.2 16.2 0 0 0 .39 11.45l50.55 121.03c.75 1.8.86 3.8.3 5.68l-11.01 37.43a2.76 2.76 0 0 0 1.75 3.4l12.45 4.24c1.4.48 2.93-.23 3.47-1.61l14.16-36.36a8.5 8.5 0 0 1 3.72-4.3l114-64.87a16.2 16.2 0 0 0 7.3-8.82l6.5-19.03z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 135.48,
			cy: 85.94,
			fill: "var(--foreground)",
			rx: 38.88,
			ry: 105.94,
			transform: "rotate(-71.15 135.48 85.94)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M194.48 138.09c-20.11 0-45.4-4.5-72.15-13.64-57.18-19.52-96.2-51.73-88.84-73.33 7.38-21.6 57.95-23.22 115.14-3.7 26.98 9.2 51.05 21.74 67.77 35.28 17.2 13.93 24.69 27.44 21.07 38.05-3.93 11.5-20.1 17.33-43 17.33ZM76.3 37.6c-21.04 0-36.03 4.92-39.37 14.69-6.48 19.01 33.16 50.47 86.57 68.7s104.02 17.58 110.5-1.43c3.05-8.92-4.2-21.33-19.9-34.04-16.4-13.28-40.07-25.6-66.66-34.67C121.5 42 96.2 37.61 76.31 37.61Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M189.62 152.2c-20.56 0-46.13-4.69-72.18-13.58C81 126.18 49.64 107.34 35.6 89.45a1.82 1.82 0 0 1 2.87-2.25c13.62 17.36 44.33 35.75 80.15 47.97 37.75 12.89 74.3 16.84 95.37 10.31a1.82 1.82 0 1 1 1.08 3.49c-7.02 2.17-15.67 3.23-25.45 3.23"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.97,
			cy: 160.75,
			r: 49.71,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m150.99 212.22-.8-.01a51.53 51.53 0 0 1-50.68-52.25 51.5 51.5 0 0 1 52.24-50.67 51 51 0 0 1 36.16 15.62 51 51 0 0 1 14.52 36.62 51 51 0 0 1-15.63 36.16 51 51 0 0 1-35.8 14.53Zm-.04-99.42a47.6 47.6 0 0 0-33.36 13.53c-9.2 8.92-14.36 20.88-14.56 33.69s4.6 24.92 13.52 34.11 20.88 14.36 33.69 14.56c12.8.19 24.92-4.61 34.1-13.53s14.37-20.88 14.57-33.68-4.61-24.92-13.53-34.11a47.6 47.6 0 0 0-34.43-14.57"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m203.76 218.55-9.55 7.77-17.37-21.34a3.5 3.5 0 0 1-.28-4.06 11.5 11.5 0 0 1 5.89-4.8 3.5 3.5 0 0 1 3.94 1.09z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M194.2 228.09c-.5 0-1.01-.23-1.36-.65l-17.37-21.34a5.3 5.3 0 0 1-.41-6.1 13.3 13.3 0 0 1 6.79-5.54 5.3 5.3 0 0 1 5.9 1.64l17.38 21.33c.61.76.5 1.87-.25 2.48l-9.56 7.78q-.51.4-1.11.4m-10.55-30.42q-.3 0-.6.1a9.7 9.7 0 0 0-5 4.07c-.38.63-.32 1.45.15 2.03l16.26 19.98 6.82-5.56-16.26-19.97a1.8 1.8 0 0 0-1.37-.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m201.01 212.61-12.07 9.83-1.12-1.38a2.5 2.5 0 0 1 .13-3.27 46 46 0 0 1 8.7-7.09 2.5 2.5 0 0 1 3.24.54z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M188.94 224.2h-.18c-.47-.05-.9-.28-1.19-.65l-1.12-1.38a4.24 4.24 0 0 1 .23-5.6 48 48 0 0 1 9.04-7.36 4.24 4.24 0 0 1 5.53.91l1.13 1.38c.61.76.5 1.87-.26 2.48l-12.07 9.83q-.48.39-1.11.4m9.03-12.11a1 1 0 0 0-.38.1 44 44 0 0 0-8.37 6.82.7.7 0 0 0-.04.94l.01.01 9.34-7.6v-.01a.7.7 0 0 0-.56-.27Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M234.7 250.77a6.6 6.6 0 0 1 1.14 6.34 12.6 12.6 0 0 1-3.2 5.03 12.7 12.7 0 0 1-7.21 3.38 6.6 6.6 0 0 1-6-2.4l-30.25-37.15a3.6 3.6 0 0 1 .06-4.57 38 38 0 0 1 10.7-8.7 3.6 3.6 0 0 1 4.48.87z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M224.59 267.33a8.5 8.5 0 0 1-6.53-3.1l-30.24-37.15a5.34 5.34 0 0 1 .08-6.82 40 40 0 0 1 11.18-9.1 5.3 5.3 0 0 1 6.7 1.3l30.29 37.2a8.3 8.3 0 0 1 1.43 8.03 14 14 0 0 1-3.64 5.73 14.5 14.5 0 0 1-9.27 3.91m-22.94-53.31q-.46 0-.87.22a36 36 0 0 0-10.2 8.3 1.8 1.8 0 0 0-.03 2.32l30.24 37.15a4.9 4.9 0 0 0 4.4 1.76q3.7-.49 6.23-2.9a11 11 0 0 0 2.75-4.33c.55-1.6.24-3.34-.83-4.66l-30.29-37.2a1.8 1.8 0 0 0-1.4-.66"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 148.51,
			cy: 157.67,
			r: 49.71,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M148.52 209.14h-.8a51 51 0 0 1-36.16-15.63 51 51 0 0 1-14.51-36.62 51.53 51.53 0 0 1 52.24-50.68 51.53 51.53 0 0 1 50.68 52.25 51.53 51.53 0 0 1-51.45 50.68m-.03-99.41a48 48 0 0 0-47.92 47.21 47.6 47.6 0 0 0 13.52 34.11 47.7 47.7 0 0 0 34.43 14.57 48 48 0 0 0 47.93-47.22 48 48 0 0 0-47.95-48.67m49.72 48.7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 148.51,
			cy: 157.67,
			r: 40.99,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M148.51 200.43h-.66c-11.42-.18-22.08-4.8-30.03-13s-12.24-19-12.06-30.41a42.5 42.5 0 0 1 12.98-30.04 42.4 42.4 0 0 1 30.42-12.06 42.8 42.8 0 0 1 42.1 43.4 42.8 42.8 0 0 1-42.75 42.1Zm-.02-81.99a39 39 0 0 0-27.3 11.07 39 39 0 0 0-11.91 27.56c-.16 10.48 3.77 20.4 11.06 27.92s17.09 11.75 27.57 11.9a39.3 39.3 0 0 0 39.82-38.62 39.3 39.3 0 0 0-39.24-39.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m120.51 169.75 46.62-35.18 9.37 12.42-46.61 35.18z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m124.71 139.75 12.42-9.38L172.31 177l-12.42 9.37z"
		})
	]
});
export default SvgFilterNone;
